/* eslint-disable @typescript-eslint/restrict-template-expressions */
import Box from '@mui/material/Box';
import { createSearchParams, useNavigate } from 'react-router-dom';
import SidebarLayout from '../../layouts/SidebarLayout';
import CustomButton from '../../components/UI/CustomButton/CustomButton';
import { useEffect, useState } from 'react';
import { loaderActions } from '../../store/loader';
import { useDispatch } from 'react-redux';
import { useSpecialtyService } from '../../hooks';
import { Specialty } from '../../../domain/entities';

const Specialties = () => {
  const SpecialtyService = useSpecialtyService();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = { specialty: '' };

  const isLoading = (state: boolean) => {
    dispatch(loaderActions.setLoading(state));
  };

  const [specialties, setSpecialties] = useState<Specialty[]>([]);

  useEffect(() => {
    isLoading(true);

    SpecialtyService.listSpecialties()
      .then((specialties) => setSpecialties(specialties))
      .catch((err) => console.log(err))
      .finally(() => isLoading(false));
  }, []);

  const navigateToMedicalCenter = (key: string) => {
    params.specialty = key;
    navigate({
      pathname: '/citas/especialidades/centros',
      search: `?${createSearchParams(params)}`
    });
  };

  return (
    <SidebarLayout>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <h2>¿En cuál especialidad desea agendar una cita?</h2>
      </Box>
      <Box
        display='grid'
        gap={2}
        sx={{
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)'
          }
        }}
      >
        {specialties.map((specialty) => (
          <CustomButton
            key={specialty.code}
            color={specialty.color}
            className='crearButton'
            onClick={() => navigateToMedicalCenter(specialty.code)}
          >
            {specialty.name}
          </CustomButton>
        ))}
      </Box>
    </SidebarLayout>
  );
};

export default Specialties;
